import { __decorate } from "tslib";
import { proxy, subscribe } from '@/infrastructure/object-reactive/object-reactive';
import { injectable } from '@/inversify.config';
import { DEFAULT_USER_INFO } from '../constants';
let UserInfoModelImpl = class UserInfoModelImpl {
    constructor() {
        this._userInfo = proxy(null);
    }
    get userInfo() {
        return this._userInfo.value;
    }
    updateUserInfo(userInfo) {
        this._userInfo.value = {
            ...DEFAULT_USER_INFO,
            ...this.userInfo,
            ...userInfo,
        };
    }
    updateUserInfoFreeView(isFreeView) {
        this._userInfo.value.is_free = isFreeView;
    }
    updateUserInfoIsCreatedSpace(isCreatedSpace) {
        this._userInfo.value.is_created_space = isCreatedSpace;
    }
    updateUserInfoSpaceDataCount(dataCount) {
        this._userInfo.value.total_company_data_count = dataCount.total_company_data_count;
        this._userInfo.value.total_personal_data_count = dataCount.total_personal_data_count;
    }
    subscribeUserInfo(callback) {
        const dispose = subscribe(() => this._userInfo.value, (newVal) => {
            callback(newVal);
        });
        return dispose;
    }
};
UserInfoModelImpl = __decorate([
    injectable()
], UserInfoModelImpl);
export { UserInfoModelImpl };
